import { LoadingStates } from '@pb/utils'

import appSelectors from 'App/duck/selectors'

import UnreviewedsState from './types'

const getUnreviewedProducts = (state): UnreviewedsState => state?.unrevieweds
const getUnreviewedProductsLoadingState = (state): string =>
  getUnreviewedProducts(state).loadingUnreviewedProductsStatus
const getUnreviewedProductsLoading = (state): boolean =>
  appSelectors.getShowLoaders(state) ||
  getUnreviewedProductsLoadingState(state) === LoadingStates.Loading
const getCreateReviewStatus = (state): UnreviewedsState => {
  return state?.unrevieweds?.creatingReviewSubmitted
}
const getHeaderStatus = (state): string => {
  return state?.unrevieweds?.headerStatus
}

export default {
  getUnreviewedProducts,
  getUnreviewedProductsLoadingState,
  getUnreviewedProductsLoading,
  getCreateReviewStatus,
  getHeaderStatus,
}
